import hash from 'object-hash';

export const getCompareFields = (entity) => {
  const pickFields = {
    stakeholders: [
      'category',
      'subCategory',
      'country',
      'name',
      'economicSector'
    ],
    locations: [
      'category',
      'country',
      'locationName',
    ],
    scp: [
      'category',
      'subCategory',
      'country',
      'name',
      'economicSector'
    ],
    scl: [
      'category',
      'country',
      'locationName',
    ],
    lir: [
      'category',
      'subCategory',
      'country',
      'name',
    ],
    administrativeLevel1: [
      'country',
      'name',
      'level',
    ],
    administrativeLevel2: [
      'country',
      'name',
      'level',
      'administrativeLevel1',
    ],
    administrativeLevel3: [
      'country',
      'name',
      'level',
      'administrativeLevel1',
      'administrativeLevel2',
    ],
    administrativeLevel4: [
      'country',
      'name',
      'level',
      'administrativeLevel1',
      'administrativeLevel2',
      'administrativeLevel3',
    ],
    administrativeLevel5: [
      'country',
      'name',
      'level',
      'administrativeLevel1',
      'administrativeLevel2',
      'administrativeLevel3',
      'administrativeLevel4',
    ],
    administrativeLevel6: [
      'country',
      'name',
      'level',
      'administrativeLevel1',
      'administrativeLevel2',
      'administrativeLevel3',
      'administrativeLevel4',
      'administrativeLevel5',
    ],
    administrativeLevel7: [
      'country',
      'name',
      'level',
      'administrativeLevel1',
      'administrativeLevel2',
      'administrativeLevel3',
      'administrativeLevel4',
      'administrativeLevel5',
      'administrativeLevel6',
    ],
    administrativeLevel8: [
      'country',
      'name',
      'level',
      'administrativeLevel1',
      'administrativeLevel2',
      'administrativeLevel3',
      'administrativeLevel4',
      'administrativeLevel5',
      'administrativeLevel6',
      'administrativeLevel7',
    ],
    administrativeLevel9: [
      'country',
      'name',
      'level',
      'administrativeLevel1',
      'administrativeLevel2',
      'administrativeLevel3',
      'administrativeLevel4',
      'administrativeLevel5',
      'administrativeLevel6',
      'administrativeLevel7',
      'administrativeLevel8',
    ],
    administrativeLevel10: [
      'country',
      'name',
      'level',
      'administrativeLevel1',
      'administrativeLevel2',
      'administrativeLevel3',
      'administrativeLevel4',
      'administrativeLevel5',
      'administrativeLevel6',
      'administrativeLevel7',
      'administrativeLevel8',
      'administrativeLevel9',
    ]
  };
  return pickFields[entity];
};

export const getCollectId = (entity, data) => {
  const pickFields = getCompareFields(entity).reduce((item, key) => {
    if (key === 'name' || key === 'locationName') {
      item[key] = data[key].trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    } else {
      item[key] = data[key];
    }
    return item;
  }, {});
  return hash(pickFields);
}

export const keysWithNoShowIf = ['name'];

export const getFilteredOptions = (d, options) => {
  const optionsToReturn = [];
  const data = { ...d };

  if (options) {
    options.forEach((o) => {
      if (!o.filters) {
        optionsToReturn.push(o);
      } else {
        let isValid = true;
        o.filters.forEach((filter) => {
          if (filter.name === 'stkCategory') {
            filter.name = 'category';
          }
          if (filter.name === 'locCategory') {
            data.locCategory = 'scl';
          }
          if (data[filter.name]) {
            switch (filter.condition) {
              case 'includes':
                if (!filter.value.includes(data[filter.name])) {
                  isValid = false;
                }
                break;
              default:
            }
          } else {
            isValid = false;
            return;
          }
        });
        if (isValid) {
          optionsToReturn.push(o);
        }
      }
    });
  }

  return optionsToReturn;
};

export const getValue = (val, config) => {
  switch (config.inputType) {
    case 'select':
      const value = config.options.find((v) => v.value === val);
      if (value) {
        return value.label;
      }
      return val;
    default:
      return val;
  }
};

export const getShowIfValues = (str, data) => {
  const splittedByAnd = str.split(' && ');
  let isValid = true;

  splittedByAnd.forEach((d) => {
    if (d !== 'parent is new') {
      const splitted = d.split(' ');
      if (splitted.length === 3) {
        const key = splitted[0];
        const condition = splitted[1];
        switch (condition) {
          case 'includes':
            const values = splitted[2].split(',');
            if (Array.isArray(values)) {
              if (!values.includes(data[key])) {
                isValid = false;
              }
            }
            break;
          case 'not':
            const notValues = splitted[2].split(',');
            if (Array.isArray(notValues)) {
              if (notValues.includes(data[key])) {
                isValid = false;
              }
            }
            break;
          case 'notEmpty':
            if (!!data[key] !== Boolean(splitted[2])) {
              isValid = false;
            }
            break;
          case 'is':
            if (data[key] !== splitted[2]) {
              isValid = false;
            }
            break;
          default:
        }
      }
    }
  });

  return isValid;
};

export const MAX_SELECTIONS = 3;

export const admLevels = {
  administrativeLevel1: 'level_1',
  administrativeLevel2: 'level_2',
  administrativeLevel3: 'level_3',
  administrativeLevel4: 'level_4',
  administrativeLevel5: 'level_5',
  administrativeLevel6: 'level_6',
  administrativeLevel7: 'level_7',
  administrativeLevel8: 'level_8',
  administrativeLevel9: 'level_9',
  administrativeLevel10: 'level_10',
}

export const labels = {
  administrativeLevel1: 'Administrative Level 1',
  administrativeLevel2: 'Administrative Level 2',
  administrativeLevel3: 'Administrative Level 3',
  administrativeLevel4: 'Administrative Level 4',
  administrativeLevel5: 'Administrative Level 5',
  administrativeLevel6: 'Administrative Level 6',
  administrativeLevel7: 'Administrative Level 7',
  administrativeLevel8: 'Administrative Level 8',
  administrativeLevel9: 'Administrative Level 9',
  administrativeLevel10: 'Administrative Level 10',
}
